export default __webpack_public_path__ + "dd6cfefa735cc35c573be856c400cc7d.svg";